import * as z from 'zod';

const messageAudienceSchema = z.enum(['INTERNAL', 'EXTERNAL', 'TSP_CUST']);
export type MessageAudience = z.infer<typeof messageAudienceSchema>;

export const assetMessageSchema = z.object({
    messageText: z.string(),
    createDateTime: z.string(),
    createdUserId: z.string(),
    orderMessageId: z.number().nullable(),
    messageType: messageAudienceSchema,
});

export const messagesListInputSchema = z.object({ orderId: z.string() });
export const messagesAddInputSchema = z.object({
    orderId: z.string().min(1),
    message: z.string().min(1),
    audience: messageAudienceSchema,
});

export const messagesEditInputSchema = z.object({
    orderId: z.string().min(1),
    messageId: z.number().min(1),
    message: z.string(),
    audience: messageAudienceSchema,
});

export type AssetMessage = z.infer<typeof assetMessageSchema>;
export type MessagesListInput = z.infer<typeof messagesListInputSchema>;
export type MessagesAddInput = z.infer<typeof messagesAddInputSchema>;
export type MessagesEditInput = z.infer<typeof messagesEditInputSchema>;

export const isAssetMessageSchema = (value: unknown): value is AssetMessage => {
    return assetMessageSchema.safeParse(value).success;
};

export const isMessageAudience = (value: unknown): value is MessageAudience => {
    return messageAudienceSchema.safeParse(value).success;
};
